import { FhsAxios } from "../../services/axios";

export default {
  data() {
    return {
      form_control_bodies: [
        {
          type: "super",
          title: "Высший орган",
          need_to_delete: [],
          data: null,
          name: ""
        },
        {
          type: "executive",
          title: "Управляющий орган",
          need_to_delete: [],
          data: null,
          name: ""
        },
        {
          type: "other",
          title: "Иной орган",
          need_to_delete: [],
          data: null,
          name: ""
        }
      ],
      form_list: []
    };
  },
  computed: {
    controlBodies() {
      if (this.user_profile) {
        return this.form_control_bodies.map(body => {
          body.need_to_delete = this.form_list.filter(
            item => item.type === body.type
          );
          if (body.need_to_delete.length > 0) {
            body.data = body.need_to_delete[body.need_to_delete.length - 1];
          } else {
            body.data = null;
          }
          return body;
        });
      }
      return [];
    }
  },
  methods: {
    getBodyControl(type) {
      return this.controlBodies.filter(body => body.type === type)[0] || null;
    }
  }
};
